import EditCoursesSector from './EditCoursesSector';

export default EditCoursesSector;
